exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-row[data-v-577592be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 4px;\n  margin-top: 4px;\n}\n.toolbar-switch > v-input__append-outer[data-v-577592be] {\n  margin-left: 0 !important;\n}\n", ""]);

// exports
